import { parseBriefSpec } from 'helpers/briefSpec';
import { removeMarkdownSyntax } from 'helpers/HelperFunctions';

const FLAT_QNA_MARKERS = [
  'Budget range:',
  'In what capacity are you hiring?',
  'Where are you in the hiring process?',
  'What type of work is this?',
  'What experience level is needed?',
  'Who are you, and what do you do?',
  'Examples:',
];

/**
 * Strip scraped aggregated preamble before the real job body.
 * Some external posts use "Job Description\n---"; others lead with
 * "Client: … Location: … Contract: …".
 *
 * @param {string} spec
 * @returns {string}
 */
export function stripAggregatedPreamble(spec = '') {
  let text = spec;

  const jobDescriptionParts = text.split(/Job Description\s*\n-+\s*/i);
  if (jobDescriptionParts.length === 2) {
    text = jobDescriptionParts[1];
  }

  text = text.replace(/^(Client|Location|Contract)\s*:[^\n]*\n?/gim, '');

  return text.trim();
}

/**
 * Cut everything from the first flat posting-form Q&A marker onward.
 * Handles excerpts where answers were concatenated without markdown headings.
 *
 * @param {string} text
 * @returns {string}
 */
export function stripFlatQnaAppendix(text = '') {
  const lower = text.toLowerCase();
  let cut = text.length;

  FLAT_QNA_MARKERS.forEach((marker) => {
    const index = lower.indexOf(marker.toLowerCase());
    if (index !== -1 && index < cut) {
      cut = index;
    }
  });

  return text.slice(0, cut).trim();
}

/**
 * Drop a trailing Budget range markdown block left in by parseBriefSpec.
 *
 * @param {string} description
 * @returns {string}
 */
function stripBudgetMarkdownBlock(description = '') {
  return description
    .replace(
      /(?:^|\n)\*\*[^*\n]*budget[^*\n]*\*\*[ \t]*\n[\s\S]*?(?=\n\*\*[^*\n]+\*\*|$)/gi,
      '\n'
    )
    .trim();
}

/**
 * Build a plain-text job-card excerpt without mutating stored description data.
 *
 * @param {string} spec
 * @returns {string}
 */
export function getJobCardExcerpt(spec = '') {
  if (!spec) {
    return '';
  }

  const withoutPreamble = stripAggregatedPreamble(spec);
  const { description } = parseBriefSpec(withoutPreamble);
  const withoutBudget = stripBudgetMarkdownBlock(description);
  const plain = removeMarkdownSyntax(withoutBudget).replace(/\s+/g, ' ').trim();

  return stripFlatQnaAppendix(plain);
}
